<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">智慧农业生产数字化解决方案</h1>
        <p class="banner-desc aw-anim">构建农田数字管理体系，全链路管控农事与农资，智能预警风控，沉淀数据支撑产销经营决策</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage2",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/smartAgri/intro_mock.png"),
      valueImg: require("@/assets/solution/smartAgri/value_mock.png"),
      introText: "聚焦农业生产全流程数字化管理，依托平台数据孪生、空间GIS、AI智能感知能力，面向家庭农场、种植合作社、农业企业，构建标准化、精细化、智能化的生产管理体系。覆盖地块资源、种植批次、农事作业、投入品管控、农机运维、生产分析全场景，联动AI智能体实现农事智能推荐、风险预警，打造数字精准农业生产模式",
      valueText: "实现农业生产标准化、精细化管控，规范农事作业流程，降低生产损耗与人工成本；依托AI与数字孪生技术提升种植科学性，降低生产风险；沉淀标准化生产数据，为产品溯源、产销对接、品牌建设提供可信数据支撑",
      painPoints: [
        {
          icon: require("@/assets/solution/smartAgri/sol_isol_pain1.png"),
          title: "数据分散",
          desc: "地块、作物、农事数据无统一管理，生产过程人工记录，台账混乱、追溯困难",
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_isol_pain2.png"),
          title: "风险难预判",
          desc: "农事作业依赖经验，缺乏智能化指导，病虫害、气象灾害风险预判能力弱",
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_isol_pain3.png"),
          title: "投入失控",
          desc: "农资、农机等生产投入品管控松散，生产成本核算模糊",
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_isol_pain4.png"),
          title: "数据沉不下",
          desc: "生产数据无法沉淀复用，不能为产销对接、经营决策提供数据支撑",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/smartAgri/sol_cap1.png"),
          title: "空间数字孪生管理",
          desc: "GIS地块确权、作物分布可视化、种植批次管理、全域农田态势监测",
          featured: true,
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_cap2.png"),
          title: "全流程农事管控",
          desc: "农事计划制定、任务派发、现场打卡、作业留痕、智能巡田",
          featured: false,
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_cap3.png"),
          title: "生产资源管理",
          desc: "种子、农药、化肥等投入品溯源管控，农机设备台账、作业调度、运维管理",
          featured: false,
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_cap4.png"),
          title: "AI智能赋能",
          desc: "病虫害智能识别、农事周期推荐、气象灾害预警、产量态势预测",
          featured: false,
        },
        {
          icon: require("@/assets/solution/smartAgri/sol_cap5.png"),
          title: "生产数据分析",
          desc: "种植效益统计、生产台账自动生成、生产态势可视化分析",
          featured: false,
        },

      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/smartAgri/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 518px;
    height: 345px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg1.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 302px;
    display: block;
  }
}
</style>